<template>
  <div class="BomComparisonComponent DataTables">
    

    <p v-if="boms.length > 1 && selectedRevisionRow.length == 1">{{lang.infotext_1}}:</p>
    <p v-if="boms.length <= 1 && selectedRevisionRow.length == 1">{{lang.infotext_2}}</p>
    <p v-if="selectedRevisionRow.length != 1">{{ lang.infotext_3 }}</p>
    
    <div v-if="boms.length > 1 && selectedRevisionRow.length == 1" :id=" id"></div>

    <LoaderComponent v-if="!isData && boms.length > 1 && selectedRevisionRow.length == 1"></LoaderComponent>

  </div>
</template>
<script>

import LoaderComponent from "@/components/shared/LoaderComponent";
import $ from 'jquery';
import dt from 'datatables.net-bs4';
import * as Tools from './../../Tools/Tools'

export default {
  name: 'BomComparisonComponent',
  props:{
    lang: Object,
    parent: String
  },
  components: {
    LoaderComponent

  },
  data () {
      return {
        name: 'BomComparisonComponent',
        mainTable: "",
        id: "BomComparisonComponent" + this._uid,
        columns: [],
        colsAssign: [],
        boms: [],
        differentialBom: [],
        parts: [],
        isData: false

      }
  },
  computed: {
    lastRevisionHistory() {
      if (this.$store.getters.revisionHistory == null) {
        return
      }
      let tab = this.$store.getters.revisionHistory;
      let obj = tab[0];
      for (let i = 0, lei = tab.length; i < lei; i++) {

        if (tab[i].revision > obj.revision) {
          obj = tab[i];
        }
      }

      return obj;
    },
    selectedRevisionRow(){
        return this.$store.getters.selectedRevisionRow;
    },
    
    revisionId() {
      // if (this.selectedRevisionRow == undefined || this.selectedRevisionRow.length == 0) {
      //   return this.$route.query.revisionId;
      // }
      // return this.selectedRevisionRow[0].revisionId;
      if (this.$route.path == "/ProjectManager/ProjectDetails") {
        if (this.$store.getters.selectedRevisionRow.length == 0) {
          return null;
        }
        return this.$store.getters.selectedRevisionRow[0].revisionId;
      }
      if (this.$route.query.revisionId != undefined) {
        return this.$route.query.revisionId;
      }

      if (this.$store.getters.selectedRevisionRow.length == 0) {
        return null;
      }

      return this.$store.getters.selectedRevisionRow[0].revisionId;
      
      
    },
       
    reloadedAfterAction(){
        return this.$store.getters.reloadedAfterAction;
    }

  },
  created () {
   
    if (this.revisionId != null) {
      
      this.getBoms();
    }
    

    //this.createTable();
    
    this.$store.dispatch(this.$store.getters.sectionPrefix + "_removeCheckboxVariant");

  },
  watch: {
    selectedRevisionRow: {
      handler: function (newVal, oldVal) {
       
        this.getBoms();
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_removeCheckboxVariant");
      },
      deep: true
    
      
    },
    
    reloadedAfterAction: function(newValue, oldValue){

      if (newValue.name == this.name){
        if (newValue.status == true){
         
            this.getBoms();
            
            newValue.status = false;
            newValue.name = "";
            this.$store.dispatch("reloadAfterAction", newValue);
        }
      }
    }
  },
  updated() {
      
  },
  mounted: function () {

  },
  methods: {
    getBoms(){
      
        let vue = this;

        const obj = {
            projectRevisionId: this.revisionId
        }  
        

        this.$store.dispatch(this.$store.getters.sectionPrefix + "_getBoms", obj)
        .then((result) => {
          console.log(result)
          if (result.status == "OK"){

            vue.boms = result.data;
            vue.isData = true;  
            

            if (vue.boms.length > 1){
                vue.buildColumns();
            }
            


          }else{
              vue.isData = false;  
          }


        })



    },
    buildColumns(){

      this.columns = [
        
        {
          name: this.lang.table_header_PartReference,
          alignInColumn: "left",
          type: "text"
        },

      ]

      this.colsAssign =  [
        //{ "data": "bomPartId" },
        { "data": "partReference" },
                
      ]

      for (let i = 0, lei = this.boms.length; i < lei; i++){
          
        const ob = {
          name: this.boms[i].name,
          alignInColumn: "left",
          type: "taxt"
        }
        this.columns.push(ob);

        const ob2 = { "data": "variant_" + i };
        this.colsAssign.push(ob2);
      }

      this.getDifferentialBom();
      
    },
    getDifferentialBom(){

        let vue = this;

        const obj = {
            revisionId: this.revisionId
        }  
        

        this.$store.dispatch(this.$store.getters.sectionPrefix + "_bomComparison", obj)
        .then((result) => {
          console.log(result)
          if (result.status == "OK"){

            this.differentialBom = result.data;
            
            vue.createData();
            

          }


        })

    },
    createData(){
        const temp = [];
        this.parts = [];
        const partRef = [];
        for (let i = 0, lei = this.boms.length; i < lei; i++){
            
            const obj = {
                name: "variant_" + i,
                bomId: this.boms[i].bomId
            }
                      
            temp.push(obj)
            
        }
        for (let j = 0, lej = this.differentialBom.length; j < lej; j++){
            
                
            const obj = {
                partReference: this.differentialBom[j].PartReference
            }
            for (let i = 0, lei = this.boms.length; i < lei; i++){
                
              
              obj[temp[i].name] = "DNI";
              
            }
            if (!partRef.includes(this.differentialBom[j].PartReference)){
                partRef.push(this.differentialBom[j].PartReference)
                this.parts.push(obj)
            }
                       
        }



        for (let j = 0, lej = this.differentialBom.length; j < lej; j++){
            
               
            
            
            for (let i = 0, lei = this.parts.length; i < lei; i++){
                
                if (this.differentialBom[j].PartReference == this.parts[i].partReference){
                    for (let k = 0, lek = temp.length; k < lek; k++){
                        
                        if (this.differentialBom[j].bomId == temp[k].bomId){
                            //console.log(this.parts[i][temp[i].name],this.differentialBom[j].PartNumber)
                          if (this.differentialBom[j].isPresent == true) {
                            this.parts[i][temp[k].name] = this.differentialBom[j].PartNumber;
                          }
                            
                        }
                    
                    }
                    
                }

            }
            
                        
        }


        this.buildTable();


    },
    
    buildTable(){
          
          var tableplace = document.getElementById(this.id);
          if (tableplace == null){
            return;
          }

          while (tableplace.firstChild) {
              tableplace.removeChild(tableplace.firstChild);
          }

          var table = document.createElement("table");
          table.setAttribute("id", "t_" + this.id);
          table.setAttribute("style", "width:100%");
          table.setAttribute("class", "table table-striped table-bordered");
          tableplace.appendChild(table)

          var tr = document.createElement("tr");
          tr.setAttribute("class", "cellHeader");
          var thead = document.createElement("thead");
          thead.appendChild(tr);
          table.appendChild(thead);

          var vue = this;


          let columnDefs = [];
          var len = this.columns.length;
          for (var i = 0; i < len; i++){

            var el = {};

            var classname = '_dt-body-'+ this.columns[i].alignInColumn;

            el = {
              targets: i,
              className: classname,

              render: function ( data, type, row, meta ) {
                if (data == null) {
                  data = "";
                }

                data = $.fn.dataTable.render.text().display(data);
                if (data.display != undefined) {
                  data.display = $.fn.dataTable.render.text().display(data.display);
                }
                let variant = "";
                if (meta.col > 1) {
                 
                  if (data == "DNI") {
                    variant = "danger";
                    return "<b-badge class='badge badge-" + variant + "' >" + data + "</b-badge>";
                  } else {
                    if (row.variant_0 != data) {
                      variant = "warning";
                      return "<b-badge class='badge badge-" + variant + "' >" + data + "</b-badge>";
                    }
                  }
                }
                
                return data;
              }


            }

            columnDefs.push(el);


            var th = document.createElement("th");
            tr.appendChild(th);
            //var p = document.createElement("p");
            //th.appendChild(p);
            var br = document.createElement("br");
            th.appendChild(br);
            var tx = document.createTextNode(this.columns[i].name)
            th.appendChild(tx);

            if (i > 0) {
              var input = document.createElement("input");
              input.type = "checkbox";
              let index = i - 1;
              input.id = "col__" + this.columns[i].name + "__" + index;
              input.setAttribute("class", "variant-checkbox");
              th.appendChild(input);
            }
            

          }


          var option = {};
          option.paging = true;
          option.info = true;
          option.dom = '<fr<t>ip>';
          option.data= this.parts;
          option.myColumnFormats = this.columns;
          option.select = true;
          option.order = [[1, "asc"]];
          option.lengthMenu = [[20]];
          option.columns = this.colsAssign;

          option.columnDefs = columnDefs;
          option.initComplete = function () {


        

          }




          if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
              this.mainTable.destroy();
              
          }

          var _vue = this;

          this.mainTable = $('#t_'+this.id).DataTable(option);

          this.mainTable.columns.adjust().draw();

          //hide first column in table
          //this.mainTable.column( 0 ).visible( false );

          let _mainTable = this.mainTable;

          this.mainTable
          .on('select', function (e, dt, type, indexes) {

            var rowData = _mainTable.rows(indexes).data();
            

            _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setSelectedPartBomRow", rowData[0])

          })
          .on('deselect', function (e, dt, type, indexes) {
           
            
            _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteSelectedPartBomRow");
          })

          $(".variant-checkbox").on("click", noclick);

          function noclick(e) {

            e.stopPropagation();

          }

          //search input change view
          var searchplace = document.getElementById("t_"+this.id + "_filter").firstChild

          while (searchplace.firstChild) {

            if (searchplace.firstChild.textContent == "Search:"){
                searchplace.removeChild(searchplace.firstChild);
                break;
            }

          }
          searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
          searchplace.firstChild.setAttribute("class", "form-control form-control-sm")


      $(document).on('change', 'input[class="variant-checkbox"]', function (e) {


        $('input[class="variant-checkbox"]').not(this).prop('checked', false);

          let temp = e.target.id.split("__");
          let variantParts = [];
          for (let i = 0, lei = vue.parts.length; i < lei; i++) {
            let objPart = {
              partReference: vue.parts[i]["partReference"],
              partNumber: vue.parts[i]["variant_" + temp[2]]
            }
            variantParts.push(objPart);
          }
          let core = [];
          for (let i = 0, lei = vue.parts.length; i < lei; i++) {
            let ob = {
              partReference: vue.parts[i]["partReference"],
              partNumber: vue.parts[i]["variant_0"]
            }


            core.push(ob)
          }
      
        
          let obj = {};
          if (e.target.checked == true) {
            obj.variantName = temp[1];
            obj.compareVariants = true;
            obj.bom = vue.boms[temp[2]];
            obj.variantParts = variantParts;
            obj.core = core;

            vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_setCheckboxVariant", obj);
          } else {
            vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_removeCheckboxVariant");
          }
 

            

        });

        // let download_buttons = document.getElementsByClassName('button-action-download');

        // for (let i = 0, lei = download_buttons.length; i < lei; i++) {
        //     download_buttons[i].addEventListener('click', function (e){
        //     let id = this.id;
        //     let temp = id.split("_^_");
            
            

        //       const obj = {
        //         fileId: temp[1],
        //         revisionId: temp[3]
        //       }


        //        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_downloadFile", obj)
        //        .then((result) =>{


        //            console.log(result)
        //            let fileName = temp[2];
        
        //             var a = document.createElement("a");
        //             a.href = URL.createObjectURL(result);
        //             a.download = fileName;
                    
        //             document.body.appendChild(a);
                    
        //             a.click();
        //             document.body.removeChild(a);
        //        })
                
            
        //     })
        // }  
        },


  }
}
</script>


<style lang="scss">
.BomComparisonComponent{
    width: 100%;
    .dataTable{
        width: 100%;
    }
    table{
      font-size: 0.75rem;
      padding: 0px !important;
      
    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }
    table.dataTable thead th p{
      margin-right: 20px;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }
    .btn-group{
      display: block;
      padding-top: 2px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .image{
      max-width: 40px;
      border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
    }
    .imageSVG{
      max-width: 40px;
      border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
      padding: 5px;
    }
    .button-action-download{
      margin: 2px;
      padding: 0px 3px;
    }
    .variant-checkbox{
      margin-left: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/BomComparisonComponent.vue